import styled from 'styled-components'

export const Container = styled.div`
  font: normal normal normal 14px/17px Inter;
  letter-spacing: 0;
  color: ${props => props.theme.colors.color6b7786};
`

export const Description = styled.div`
  word-break: break-word;
  b {
    font-weight: bold;
  }
`
